import { combineReducers } from 'redux';
import block from './block';
import extrinsics from './extrinsics';
import socket from './socket';

export default combineReducers({
    Block       :   block,
    Extrinsics  :   extrinsics,
    Socket      :   socket
});